import moment from "moment";
import React, { useContext, useState } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { getRevenueBreakdownData } from "../../../api/report";
import ReactTable from "../../../Components/Table/Table";
import { AppContext } from "../../../Context/AppContext";
// Components
import styles from "./index.module.scss";

import { Bar } from "react-chartjs-2";
import { Doughnut } from "react-chartjs-2";
import { getAccessByModuleName } from "Routes/Routes";
import { MODULES } from "Helpers/Constants";
import { setAllStore } from "Helpers/setAllStore";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";
import { formatAmount } from "Pages/Order/Order/utility/util";

const RevenueBreakdownReport = () => {
  const navigate = useNavigate();
  const { showToastMessage, modules } = useContext(AppContext);
  let accessExport = getAccessByModuleName(
    modules,
    MODULES.REVENUE_BREAKDOWN_REPORT
  );
  const [dataCategory, setDataCategory] = React.useState([]);
  const [dataSource, setDataSource] = React.useState([]);
  const [dataLocalNonLocal, setDataLocalNonLocal] = React.useState([]);
  const [dataPayment, setDataPayment] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [chartData, setChartData] = React.useState(null);
  const [paiChartData, setPaiChartData] = React.useState(null);
  const [paiChartRawData, setPaiChartRawData] = React.useState([]);
  const [paiChartDataCount, setPaiChartDataCount] = React.useState(null);
  const [paiChartRawDataCount, setPaiChartRawDataCount] = React.useState([]);
  const [type, setType] = useState("delivery_date");
  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });
  const reference = React.useRef(null);

  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);
  const [fromDate, setFromDate] = useState(
    moment().startOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");
  const [selectedPeriodLabel, setSelectedPeriodLabel] = React.useState(
    "By Week"
  );
  
  const [checkAllStore,setCheckAllStore] = useState(true);

  const fetchDataTest = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
  }) => {
    return true;
  };

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
  }) => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    setChartData(null);
    setPaiChartData(null);
    setPaiChartDataCount(null);
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);
    const postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      date_type: type,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getRevenueBreakdownData(postData);
    if (response && response.status === 200) {
      //   ...response.data.data.revenueBreakDown,
      //   ...response.data.data.revenueBreakDownOrderData,
      //   ...response.data.data.revenueBreakDownOrderCount,
      //   ...response.data.data.revenueBreakDownPayment,

      setPageCount(0);

      let chartKey = response.data.data.revenueBreakDown.map((p) => p.title);
      let chartValue = response.data.data.revenueBreakDown.map((p) => p.status);
      let sumRevenueBreakDown = 0;
      response.data.data.revenueBreakDown.forEach((data) => {
        if (data.id !== "rewards" && data.id !== "coupons" && data.id !== "replace_coupon") {
          sumRevenueBreakDown += +data.status;
        } else {
          sumRevenueBreakDown -= +data.status;
        }
      });

      //Display subtotal of revenueBreakDown without tax
      //Revenue by category section
      let subtotal = 0;
      response.data.data.revenueBreakDown.forEach((data) => {
        if (data.id !== "tax" && data.id !== "total") {
          if (data.id !== "rewards" && data.id !== "coupons" && data.id !== "replace_coupon") {
            subtotal += +data.status;
          } else {
            subtotal -= +data.status;
          }
        }
      });

      response.data.data.revenueBreakDown.push({ title: "Subtotal ", status: subtotal.toFixed(2), id: "sub_total" });

      response.data.data.revenueBreakDown = [
        ...response.data.data.revenueBreakDown,
        ...[{ title: "Total", status: sumRevenueBreakDown.toFixed(2), id: "total" }],
      ];

      // Extract Tax item and remove it from the array
      const taxItem = response.data.data.revenueBreakDown.find(item => item.id === "tax");
      const revenueBreakDownWithoutTax = response.data.data.revenueBreakDown.filter(item => item.id !== "tax");

       // Insert Tax at second-to-last position (before Total)
       if (taxItem) {
        revenueBreakDownWithoutTax.splice(response.data.data.revenueBreakDown.length - 2, 0, taxItem);
      }

      setDataCategory(revenueBreakDownWithoutTax);

      let chartKeyOrder = response.data.data.revenueBreakDownOrderData.map(
        (p) => p.title
      );
      let chartValueOrder = response.data.data.revenueBreakDownOrderData.map(
        (p) => p.status
      );
      const sumRevenueBreakDownOrderData = chartValueOrder
        .reduce((result, number) => result + number)
        .toFixed(2);
      response.data.data.revenueBreakDownOrderData = [
        ...response.data.data.revenueBreakDownOrderData,
        ...[{ title: "Total", status: sumRevenueBreakDownOrderData, id: "total" }],
      ];
      setDataSource(response.data.data.revenueBreakDownOrderData);

      let chartKeyOrderPayment = response.data.data.revenueBreakDownPayment.map(
        (p) => p.title
      );
      let chartValueOrderPayment = response.data.data.revenueBreakDownPayment.map(
        (p) => parseFloat(p.status)
      );

      const sumRevenueBreakDownPayment = chartValueOrderPayment
        .reduce((result, number) => result + number)
        .toFixed(2);
      response.data.data.revenueBreakDownPayment = [
        ...response.data.data.revenueBreakDownPayment,
        ...[{ title: "Total", status: sumRevenueBreakDownPayment, id: "total" }],
      ];
      setDataPayment(response.data.data.revenueBreakDownPayment);

      chartKey = [...chartKey, ...chartKeyOrder, ...chartKeyOrderPayment];
      chartValue = [
        ...chartValue,
        ...chartValueOrder,
        ...chartValueOrderPayment,
      ];
      let chartSetData = {
        labels: chartKey,
        datasets: [
          {
            label: "Revenue($)",
            data: chartValue,
            backgroundColor: "rgb(228,224,229)",
          },
        ],
      };
      setChartData(chartSetData);

      let paiChartKey = response.data.data.revenueBreakDownOrderData.map(
        (p) => p.title + " %"
      );
      let paiChartValue = response.data.data.revenueBreakDownOrderData.map(
        (p) => p.per
      );

      const paiChartDataSet = {
        labels: paiChartKey,
        datasets: [
          {
            data: paiChartValue,
            backgroundColor: ["#CB998D", "#938497", "#E4E0E5", "#c6c6c6"],
            borderColor: ["#CB998D"],
            borderWidth: 0.1,
            hoverOffset: 4,
            // borderRadius:
          },
        ],
      };
      setPaiChartData(paiChartDataSet);
      setPaiChartRawData(response.data.data.revenueBreakDownOrderData);

      let paiChartCountKey = response.data.data.revenueBreakDownOrderCount.map(
        (p) => p.title + " %"
      );
      let paiChartCountValue = response.data.data.revenueBreakDownOrderCount.map(
        (p) => p.per
      );
      let paiChartCountValueStatus = response.data.data.revenueBreakDownOrderCount.map(
        (p) => p.status
      );
      const sumRevenueBreakDownOrderCount = paiChartCountValueStatus.reduce(
        (result, number) => result + number
      );

      response.data.data.revenueBreakDownOrderCount = [
        ...response.data.data.revenueBreakDownOrderCount,
        ...[
          {
            title: "Total",
            status: sumRevenueBreakDownOrderCount.toFixed(2),
            id: "total",
          },
        ],
      ];
      setDataLocalNonLocal(response.data.data.revenueBreakDownOrderCount);

      const paiChartDataCountSet = {
        labels: paiChartCountKey,
        datasets: [
          {
            data: paiChartCountValue,
            backgroundColor: ["#CB998D", "#E4E0E5"],
            borderColor: ["#CB998D"],
            borderWidth: 0.1,
            hoverOffset: 4,
            // borderRadius:
          },
        ],
      };
      setPaiChartDataCount(paiChartDataCountSet);
      setPaiChartRawDataCount(response.data.data.revenueBreakDownOrderCount);
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();
    setChartData(null);
    setPaiChartData(null);
    setPaiChartDataCount(null);
    setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");
    fetchData({
      ...defaultFilter,
      fromDateDefault: moment().startOf("isoWeek").format("YYYY-MM-DD"),
      toDateDefault: moment().endOf("isoWeek").format("YYYY-MM-DD"),
    });
  };

  const handleExportRevenue = async (
    sortBy,
    filters,
    fromDateDefault,
    toDateDefault
  ) => {

/*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    let postData = {
      sortBy,
      filters,
      isExport: true,
      date_type: type,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
    };
    const response = await getRevenueBreakdownData(postData);

    if (response && response.status === 200) {
      setExportHeader(response.data.data.header);
      setExportData(response.data.data.data);
      reference.current?.link?.click();
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  //     setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("month").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("month").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("year").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("year").format("ddd MMM DD, YYYY"));

  //     setToDate(moment(data).add(7, "days").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "months").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "years").utc().format("ddd MMM DD, YYYY"));

  //     setFromDate(
  //       moment(data).subtract(7, "days").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "months").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "years").utc().format("ddd MMM DD, YYYY")

  const columnsCat = React.useMemo(
    () => [
      {
        Header: "Revenue by Category",
        accessor: "title",
        isVisible: true,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <>
            {row.original.id == "sub_total" || row.original.id == "total" ? (
              <span style={{ color: "#000", fontWeight: "bold" }}>{value}</span>
            ) : (
                <span>{value}</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Revenue",
        accessor: "status",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return (
            <>
              {row.original.id == "rewards" || row.original.id == "coupons" || row.original.id == "replace_coupon" ? (
                <span>{"-$" + formatAmount(value)}</span>
              ) : (
                <span>{"$" + formatAmount(value)}</span>
              )}
            </>
          );
        },
      },
    ],
    []
  );
  const columnsSource = React.useMemo(
    () => [
      {
        Header: "Revenue by Source",
        accessor: "title",
        isVisible: true,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <>
            {row.original.id == "total" ? (
              <span style={{ color: "#000", fontWeight: "bold" }}>{value}</span>
            ) : (
                <span>{value}</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Revenue",
        accessor: "status",
        isVisible: true,
        Cell: ({ value }) => "$" + formatAmount(value) || 0,
      },
    ],
    []
  );
  const columnsLocalNonLocal = React.useMemo(
    () => [
      {
        Header: "Local / Non local",
        accessor: "title",
        isVisible: true,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <>
            {row.original.id == "total" ? (
              <span style={{ color: "#000", fontWeight: "bold" }}>{value}</span>
            ) : (
                <span>{value}</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Revenue",
        accessor: "status",
        isVisible: true,
        Cell: ({ value }) => "$" + formatAmount(value) || 0,
      },
    ],
    []
  );
  const columnsPayment = React.useMemo(
    () => [
      {
        Header: "Revenue by Payment",
        accessor: "title",
        isVisible: true,
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <>
            {row.original.id == "total" ? (
              <span style={{ color: "#000", fontWeight: "bold" }}>{value}</span>
            ) : (
                <span>{value}</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Revenue",
        accessor: "status",
        isVisible: true,
        Cell: ({ value }) => "$" + formatAmount(value),
      },
    ],
    []
  );

  //   },
  //     },
  //   },

  const options = {
    scales: {
      y: {
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value) {
            return "$" + value;
          },
        },
      },
    },
  };

  const selectedPeriodOptions = [
    { id: "weekly", title: "Weekly", label: "By Week" },
    { id: "monthly", title: "Monthly", label: "By Month" },
    { id: "yearly", title: "Yearly", label: "By Year" },
    { id: "custom", title: "Custom", label: "Custom" },
  ];

  return (
    <React.Fragment>
      <div className={"row"}>
        <div className="col-12 m-0 p-0">
          <GlobalDateFilters
            isDateFilter
            isSearchIcon
            isClearSearchBtn
            isAllCheckStoreBnt
            isFilterByOption
            isFilterByPeriod
            isExportBtn={!!(accessExport && accessExport.permissions.write_access)}
            exportData={exportData}
            exportHeader={exportHeader}
            handleExport={(e) => handleExportRevenue(defaultFilter)}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            type={type}
            setType={setType}
            fetchData={()=>fetchData({
              ...defaultFilter
            })}
            handleClearSearch={handleClearSearch}
            checkAllStore={(data)=>{setCheckAllStore(data)}}
            defaultSetCheckAllStore={checkAllStore}
            selectedPeriod={selectedPeriod}
            setSelectedPeriod={setSelectedPeriod}
            periodOptions={selectedPeriodOptions}
            isSelectedPeriodLabel
            selectedPeriodLabel={selectedPeriodLabel}
            setSelectedPeriodLabel={setSelectedPeriodLabel}
            key={"revenue-breakdown-report"}  
          />
          {exportData && exportData.length > 0 && (
            <CSVLink
              ref={reference}
              style={{ display: "none" }}
              data={exportData}
              headers={exportHeader}
              filename={"RevenueBreakdownReport.csv"}
            >
              DownLoad
            </CSVLink>
          )}
        </div>
      </div>
      {selectedPeriod !== "custom" && (
        <div className="row">
          <div className="col-md-9">
            {chartData && chartData?.datasets?.length !== 0 && (
              <Bar data={chartData} options={options} height={200} />
            )}
          </div>
          <div className="col-md-3">
            <div>
              {paiChartData && paiChartData?.datasets?.length !== 0 && (
                <Doughnut
                  data={paiChartData}
                  style={{ marginLeft: "50px" }}
                />
              )}

              <div className={`d-flex mt-4 ${styles.PieChartList}`}>
                <ul style={{ listStyle: "disc" }}>
                  {paiChartRawData.map((d, i) => {
                    return (
                      <li key={i}>
                        {d.title} - <span>${formatAmount(d.status)}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div>
              {paiChartDataCount &&
                paiChartDataCount?.datasets?.length !== 0 && (
                  <Doughnut
                    data={paiChartDataCount}
                    style={{ marginLeft: "50px" }}
                  />
                )}
              <div className={`d-flex mt-4 ${styles.PieChartList}`}>
                <ul style={{ listStyle: "disc" }}>
                  {paiChartRawDataCount.map((d, i) => {
                    return (
                      <li key={i}>
                        {d.title} - <span>${formatAmount(d.status)}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
      <br /> <br />
      <ReactTable
        columns={columnsCat}
        data={dataCategory}
        fetchData={fetchDataTest}
        loading={loading}
        pageCount={pageCount}
        noDataText={"There is no data to display"}
        defaultFilter={defaultFilter}
        displayGlobalSearch={false}
      />
      <ReactTable
        columns={columnsSource}
        data={dataSource}
        fetchData={fetchDataTest}
        loading={loading}
        pageCount={pageCount}
        noDataText={"There is no data to display"}
        defaultFilter={defaultFilter}
        displayGlobalSearch={false}
      />
      <ReactTable
        columns={columnsLocalNonLocal}
        data={dataLocalNonLocal}
        fetchData={fetchDataTest}
        loading={loading}
        pageCount={pageCount}
        noDataText={"There is no data to display"}
        defaultFilter={defaultFilter}
        displayGlobalSearch={false}
      />
      <ReactTable
        columns={columnsPayment}
        data={dataPayment}
        fetchData={fetchData}
        loading={loading}
        pageCount={pageCount}
        noDataText={"There is no data to display"}
        defaultFilter={defaultFilter}
        displayGlobalSearch={false}
      />
    </React.Fragment>
  );
};

export default RevenueBreakdownReport;
